var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphicLogo2Bw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 134,
    viewBox: "0 0 153 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.6408 86.831C64.6629 86.831 67.9234 84.0099 67.9234 80.53C67.9234 77.0501 64.6629 74.229 60.6408 74.229C56.6187 74.229 53.3582 77.0501 53.3582 80.53C53.3582 84.0099 56.6187 86.831 60.6408 86.831Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3171 83.9641L2.38 128.838C2.38 128.838 20.5865 100.588 2.38 80.0574L94.432 1.00098",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7446 86.0644L4.88037 131.001C4.88037 131.001 37.5307 115.249 61.2598 131.001L152.62 51.3564",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0068 16.4697L133.928 97.0594",
    stroke: "black",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicLogo2Bw);
export default __webpack_public_path__ + "static/media/graphic-logo-2-bw.e913c6516f492f29e5c1f24308466e00.svg";
export { ForwardRef as ReactComponent };